import { ReactComponent as AddIcon } from '../../components/icons/add-icon.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { ReactComponent as SearchIcon } from '../../components/icons/search.svg';
import { ReactComponent as NumSort } from '../../components/icons/num-sort.svg';
import { ReactComponent as AlphaSort } from '../../components/icons/alpha-sort.svg';
import { ReactComponent as Cup } from '../../components/icons/cup.svg';
import SortArrows from '../../components/icons/sort-arrows.jsx';
import CustomButton from '../../components/components/custom_button/customButton.jsx';
import CustomInput from '../../components/components/custom_input/customInput.jsx';
import store from '../../store/store.js'; // Import magazynu Redux
import { clearCheckedItems, toggleNeedRefresh, setKeyword, setSearchValue, setSortListEndpoint} from '../../store/sportsTabSlice';
import ApiService from '../../components/api_services/apiService';
import { changeSortingListConfiguration } from './sportsTableService.js';

// Akcje dla tabeli użytkowników
export const actions = {  
  // addSport: () => {
  //   console.log('Dodaj sport kliknięte');
  //   handleOpenModal;
  //   // Logika otwierania modala lub przekierowania do formularza dodawania sportu
  // },
 deleteSelected: async (dispatch) => {
    // Pobierz `checkedItems` ze stanu Redux    
    const state = store.getState();
    const selectedIds = state.sports.checkedItems;    

    if (selectedIds.length === 0) {
      alert('Nie wybrano żadnych elementów do usunięcia.');
      return;
    }

    try {
      const response = await ApiService.deleteSportsByIdList(selectedIds);

      // Obsługa odpowiedzi serwera
      if (response.status === 200) {
        alert('Wszystkie sporty zostały usunięte!');
      } else if (response.status === 206) {
        alert('Niektóre sporty nie mogły zostać usunięte!');
      } else if (response.status === 204) {
        alert('Nie znaleziono sportów do usunięcia!');
      }

      // Wyzerowanie zaznaczonych elementów
      dispatch(clearCheckedItems());
      dispatch(toggleNeedRefresh());

    } catch (error) {      
      console.error('Błąd podczas usuwania sportów:', error);
      alert('Wystąpił błąd podczas usuwania sportów.');
    }
  },
  // searchUsers: (query) => {
  //   console.log('Wyszukaj użytkowników:', query);
  //   // Logika wyszukiwania użytkowników
  // },
  // changeTab: (tabName, dispatch, setActiveUsersTab) => {
  //   console.log('Zmieniono zakładkę na:', tabName);
  //   dispatch(setActiveUsersTab(tabName));
  // },
};

// Konfiguracja nagłówków tabeli

export const getHeaders = (sortBy, sortDirection, dispatch, setSorting, sortArrowColorActive, sortArrowColorInactive, rowsSports, checkedItems) => [
  <input
    type="checkbox"
    checked={rowsSports.every((row) => checkedItems.includes(row[1]))}
    onChange={(e) => {
      if (e.target.checked) {
        // Dodaj wszystkie widoczne elementy do checkedItems
        rowsSports.forEach((row) => {
          if (!checkedItems.includes(row[1])) {
            dispatch({ type: 'sports/toggleCheckedItem', payload: row[1] });
          }
        });
      } else {
        // Usuń wszystkie widoczne elementy z checkedItems
        rowsSports.forEach((row) => {
          if (checkedItems.includes(row[1])) {
            dispatch({ type: 'sports/toggleCheckedItem', payload: row[1] });
          }
        });
      }
    }}
    />,
    <div className="table-columns-headers">
    <div>ID</div>
    <SortArrows
      upColor={sortBy === 'id' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'id' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'id') {
          dispatch(setSorting({ sortBy: 'id', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'id', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Nazwa dyscypliny</div>
    <SortArrows
      upColor={sortBy === 'name' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'name' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'name') {
          dispatch(setSorting({ sortBy: 'name', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'name', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Nazwa w j.angielskim</div>
    <SortArrows
      upColor={sortBy === 'name_eng' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'name_eng' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'name_eng') {
          dispatch(setSorting({ sortBy: 'name_eng', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'name_eng', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Użycie</div>    
  </div>,
  <div className="table-columns-headers">
    <div>Miniatura</div>    
  </div>,
  <div className="table-columns-headers">
    <div>Kolejność</div>
    <SortArrows
      upColor={sortBy === 'order_number' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'order_number' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'order_number') {
          dispatch(setSorting({ sortBy: 'order_number', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'order_number', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Aktywność</div>
    <SortArrows
      upColor={sortBy === 'is_active' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'is_active' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'is_active') {
          dispatch(setSorting({ sortBy: 'is_active', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'is_active', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
  <div>Akcje</div>
</div>,
];

export const empty = [];

// Szerokości kolumn
export const headerWidths = ['42px', '65px', '2fr', '2fr', '85px', '85px', '120px', '120px', '65px'];

// Konfiguracja zakładek
export const tabsConfig = (activeUsersTab, dispatch, setActiveUsersTab) => [
  {
    icon: Cup,
    name: 'Dyscypliny',
    hoverClass: 'hover-effect',
    activeClass: activeUsersTab === 'Dyscypliny' ? 'is-active' : '',
    onClick: () => {},
    toggleActive: true,
  },
];

// Konfiguracja przycisków
export const buttonsConfig = ( toggleAddModal ) => [  
  {
    icon: AddIcon,
    name: 'Dodaj dyscyplinę',
    baseClass: 'custom-button-black',
    hoverClass: 'hover-effect',
    activeClass: '',
    onClick: () => {
      toggleAddModal();
    },
    toggleActive: false,
  },
];

// Konfiguracja lewej strony
export const leftSideConfig = (dispatch) => [
  {
    component: CustomButton,
    props: {
      icon: Trash,
      name: 'Usuń zaznaczone',
      baseClass: 'custom-button-white',
      hoverClass: 'hover-effect',
      activeClass: '',
      borders: 'LRBT',
      onClick: () => actions.deleteSelected(dispatch), // Przekaż tutaj zaznaczone ID użytkowników
      toggleActive: false,
    },
  },
];

// Konfiguracja prawej strony
export const rightSideConfig = (searchValue, dispatch) => [
  {
    component: CustomInput,
    props: {
      icon: SearchIcon,
      placeholder: 'Wyszukaj',
      hoverClass: 'hover-effect',
      borders: 'LRBT',
      bordersClassPrefix: 'border-black-',
      baseClass: 'custom-input',
      activeClass: '',
      value: searchValue,
      onChange: (e) => {
        e.preventDefault();
        let value = e.target.value;
        dispatch(setSearchValue(value)); // Ustaw wartość wyszukiwania w stanie lokalnym
        if (value.length >= 3 ) {
          dispatch(setKeyword(value)); // Aktualizuj stan w Reduxie
        } else {
          dispatch(setKeyword('')); // Resetuj stan w Reduxie, jeśli mniej niż 3 znaki
        }
      },
    },
  },
];

export const sortButtonsConfig = (dispatch, sort ) => [
  {
    component: CustomButton,
    props: {
      icon: sort === "ORDER_NUMBER" ? NumSort : AlphaSort,          
      name: sort === "ORDER_NUMBER" ? "Kolejność sportów w APLIKACJI: Ustalona kolejność" : "Kolejność sportów w APLIKACJI: Alfabetycznie",
      baseClass: 'custom-button-white',
      hoverClass: 'hover-effect',
      activeClass: '',
      borders: 'LRBT',
      onClick: () => {
// Określ, jaki będzie nowy tryb sortowania
        const newSortOrder = sort === "ORDER_NUMBER" ? "ALPHABETICALLY" : "ORDER_NUMBER";
        const newSortName = newSortOrder === "ALPHABETICALLY" ? "alfabetyczną" : "ustaloną kolejność";

        // Wyświetl monit o potwierdzenie
        if (window.confirm(`Czy na pewno chcesz zmienić sposób sortowania dyscyplin w aplikacji na ${newSortName}?`)) {
          // Jeśli użytkownik potwierdzi, wykonaj oryginalne akcje
          changeSortingListConfiguration(newSortOrder);
          dispatch(setSortListEndpoint(newSortOrder));
        }
        // Jeśli użytkownik kliknie "Anuluj", nic się nie stanie.
      },
      toggleActive: false,
    },
  },
];